module.exports = {"firebase":{"apiKey":"AIzaSyBpqJLqoB11mw_I29O_-IGARp15LqHOR0Q","authDomain":"yahac-dev.firebaseapp.com","databaseURL":"https://yahac-dev.firebaseio.com","projectId":"yahac-dev","storageBucket":"yahac-dev.appspot.com","messagingSenderId":"589605679350","functionURL":"https://us-central1-yahac-dev.cloudfunctions.net"},"uploadcare":{"UPLOADCARE_PUBLIC_KEY":"3e3ef11a3b587b2da4b8"}}


//////////////////
// WEBPACK FOOTER
// ./src/config.dev.json
// module id = 1086
// module chunks = 0